/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_CityInputs */

const en_entity_city = /** @type {(inputs: Entity_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

const de_entity_city = /** @type {(inputs: Entity_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stadt`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Entity_CityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_city = /** @type {((inputs?: Entity_CityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_CityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_city(inputs)
	return de_entity_city(inputs)
});